/* eslint-disable react/jsx-fragments */
import {
  IconButton,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Portal,
} from '@chakra-ui/react';

import { Fragment } from 'react';
import { VerticalEllipsis } from '@/client/components/icons/ContinuIcons';

interface WarmNeutralTableActionsMenuProps {
  actions: {
    label: string;
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
    shouldRender?: boolean;
  }[];
  isDisabled?: boolean;
}

export default function WarmNeutralTableActionsMenu({
  actions,
  isDisabled = false,
}: WarmNeutralTableActionsMenuProps) {
  const hasNoAvailableActions = actions.every((action) => action.shouldRender === false);

  return (
    <Menu>
      <MenuButton
        variant="unstyled"
        isDisabled={isDisabled || hasNoAvailableActions}
        as={IconButton}
        aria-label="Table Actions Menu"
        color="neutral.400"
        icon={<VerticalEllipsis />}
        borderRadius="full"
        onClick={(event) => event.stopPropagation()}
        _hover={{
          backgroundColor: 'neutral.50',
        }}
      />

      <Portal>
        <MenuList
          paddingY={2}
          paddingX={4}
          border="1px solid"
          borderColor="warmNeutral.200"
          borderRadius="6px"
          minWidth={0}
          width="fit-content"
        >
          {actions.map((action, index) => {
            if (action.shouldRender === false) return null;

            return (
              <Fragment key={action.label}>
                <MenuItem
                  key={action.label}
                  fontSize="14px"
                  fontWeight={500}
                  borderRadius="4px"
                  onClick={action.onClick}
                  _hover={{ backgroundColor: 'warmNeutral.100' }}
                >
                  {action.label}
                </MenuItem>

                {index !== actions.length - 1 && <MenuDivider color="warmNeutral.200" />}
              </Fragment>
            );
          })}
        </MenuList>
      </Portal>
    </Menu>
  );
}
